import { FC } from 'react';

/** @info Videoly HTML with list of videos is injected through GTM script */
export const VideolyVideoboxPlaceholder: FC = () => {
    return <div id="videoly-videobox-placeholder" />;
};
